module.exports = __webpack_public_path__ + "static/media/login-bg-web-viewer.4386760f.png";